// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Popup_dialog__2dil6","backdrop":"Popup_backdrop__3vMGf","icon":"Popup_icon__2zl1i"};